import axios from "axios";
import { IP_ADDRESS } from "../../config";
import { handleAxiosError } from "../error.handler.service";
export const getAppVersionNumber = async () => {
  return axios
    .get(`${IP_ADDRESS}/app/version`)
    .then((result) => result?.data)
    .catch((error) => handleAxiosError(error));
};

export const getAllApps = async () => {
  return axios
    .get(`${IP_ADDRESS}/app/appList`)
    .then((result) => result?.data)
    .catch((error) => handleAxiosError(error));
};

export const getBillingStatus = async (company_name, canSeeBilling) => {
  return axios
    .post(`${IP_ADDRESS}/billing/authorization/status`, {
      company_name: company_name,
    })
    .then((result) => result?.data)
    .catch((error) => handleAxiosError(error));
};
